// src/components/layouts/admindashboard/sidebar/sub/SidebarHeader.tsx

import React from "react";
import { Link } from "react-router-dom";

const SidebarHeader: React.FC = () => {
  return (
    <div className="border-b border-accent/20 px-5 py-6">
      <div className="flex items-center gap-3">
        <Link to="/" className="relative group">
          <div className="absolute inset-0 bg-accent/30 rounded-full blur-md opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
          <img
            src="/assets/logo/logoPsaumesetplantes-removebg-preview.png"
            alt="Psaumes et Plantes"
            className="h-12 w-12 object-contain bg-white rounded-full transition-all duration-300 p-1 group-hover:scale-105 group-hover:shadow-lg group-hover:shadow-accent/20"
          />
        </Link>
        <div>
          <h1 className="text-sm font-bold tracking-tight bg-gradient-to-r from-white to-accent/80 bg-clip-text text-transparent">
            Psaumes & Plantes
          </h1>
          <p className="text-xs font-medium text-white mt-0.5 italic">
            L'efficacité des Psaumes et Plantes
          </p>
        </div>
      </div>
    </div>
  );
};

export default SidebarHeader;